import { Role, Permission } from './role';
import { httpClient } from './httpClient';
import { replaceSymbols } from '../utils';
import { CategoryItem } from '../types/category';
import { STORAGEREFRESHTOKENKEY } from '../auth/context/jwt/auth-provider';

export interface Products {
  id: string;
  roles: Role[];
  name: Product;
}
export interface User {
  id?: number;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  createdAt?: string;
  updatedAt?: string;
  mobile?: string;
  avatar: string;
  dateOfBirth: string;
  gender: string;
  products: Products[];
  roles: Role[];
  permissions?: Permission;
  category?: CategoryItem;
}
export enum Product {
  ERP = 'ERP',
  AMOEBA = 'AMOEBA',
  SRM = 'SRM',
  CUMS = 'CUMS',
  PRC = 'PRC',
}

export const getProductPath: Record<Product, unknown> = {
  [Product.AMOEBA]: '',
  [Product.SRM]: import.meta.env.VITE_SRM_URL,
  [Product.ERP]: import.meta.env.VITE_ERP_URL,
  [Product.CUMS]: import.meta.env.VITE_USER_URL,
  [Product.PRC]: import.meta.env.VITE_PRC_URL,
};
export interface AuthProps {
  username: string;
  password: string;
}

export interface AuthResponse {
  user: User;
  token: string;
}

export async function getAllUsers(): Promise<User[]> {
  const response = await httpClient.sendRequest({
    url: 'users?includeRole=1',
    method: 'GET',
  });
  return response.data;
}

export async function getUserProfile(): Promise<User> {
  const response = await httpClient.sendRequest({
    url: `${import.meta.env.VITE_USER_API_URL}users/profile`,
    method: 'GET',
    headers: {
      product: Object.values(Product).join(),
    },
  });
  return response.data;
}

export async function getAccessToken(
  product: Product,
  refreshToken?: string
): Promise<{ token: string; refreshToken: string }> {
  const response = await httpClient.sendRequest({
    url: `${import.meta.env.VITE_USER_API_URL}auth/access_token`,
    method: 'POST',
    data: {
      product,
      refreshToken: refreshToken || localStorage.getItem(STORAGEREFRESHTOKENKEY),
    },
  });
  return response.data;
}

export const logoutForBackend = async (username: string) => {
  const response = await httpClient.sendRequest({
    url: `${import.meta.env.VITE_USER_API_URL}auth/logout`,
    method: 'POST',
    data: {
      username,
    },
  });
  return response.data;
};

// 单个文件上传
export async function uploadImage(image: File) {
  // 步骤1：获取上传URL
  const response = await httpClient.sendRequest({
    url: `users/upload-url`,
    method: 'POST',
    data: {
      filename: replaceSymbols(image.name || ''), // 处理文件名特殊字符
    },
  });

  // 步骤2：直接上传到云存储
  const uploadResult = await httpClient.upload(response.data.uploadUrl, image);

  // 步骤3：返回文件访问URL
  return response.data.fileUrl;
}

// 批量文件上传
export async function uploadImages(images: File[]) {
  const results = await Promise.all(images.map((image) => uploadImage(image)));
  return results;
}
